export enum RoutePath {
  Default = "",
  Login = "login",
  NotAuthorized = "not-authorized",
  Logs = "logs",
  HealthCheck = "health",
  ActiveUser = "active-user",
  RegisterPassword = "register-password",

  Main = "main",

  Home = "main/home",

  Users = "main/users",
  SearchUser = "main/users/search-user",
  RegisterUser = "main/users/register-user",

  Companies = "main/companies",
  SearchCompany = "main/companies/search-company",
  RegistrationCompany = "main/companies/registration-company",
  CreateCompany = "main/companies/create-company",
  EditCompany = "main/companies/edit-company",

  Beneficiaries = "main/beneficiaries",
  SearchBeneficiary = "main/beneficiaries/search-beneficiary",
  RegistrationBeneficiary = "main/beneficiaries/registration-beneficiary",
  ExportBeneficiary = "main/beneficiaries/export-beneficiary",
  RegistrationDependent = "main/beneficiaries/registration-dependent",
  EditBeneficiary = "main/beneficiaries/edit-beneficiary",
  EditDependent = "main/beneficiaries/edit-dependent",
  RegistrationBeneficiaries = "main/beneficiaries/registration-beneficiaries",
  BlockBeneficiaries = "main/beneficiaries/block-beneficiaries",
  UnblockBeneficiaries = "main/beneficiaries/unblock-beneficiaries",
 
  Campaigns = "main/campaigns",
  CreateCampaign = "main/campaigns/create",
  EditCampaign = "main/campaigns/edit",
  Benefits = "main/benefits",
  SearchBenefit = "main/benefits/search-benefit",
  EditBenefit = "main/benefits/edit-benefit",
  VisualizeBenefit = "main/benefits/visualize-benefit",
  AddBenefit = "main/benefits/registrer-benefit",

  SalesHistories = "main/sales-histories",
  SalesHistoryCompanies = "main/sales-histories/sales-history-companies",
  SalesHistoryCompany = "main/sales-histories/sales-history-company",

  FinancialStatement = "main/financial-statement",
  SearchFinancialStatement = "main/financial-statement/search-financial-statement",
  FinancialStatementCompany = "main/financial-statement/financial-statement-company",
  FinancialStatementBeneficiary = "main/financial-statement/financial-statement-beneficiary",

  NetworkFinancialStatmentPayment = "main/network-financial-statement-payment",
  NetworkFinancialStatements = "main/network-financial-statements",
  SearchNetworkFinancialStatement = "main/network-financial-statements/search-network-financial-statement",

  CompanyFinancialReport = "main/financial-report/company-financial-report",

  NetworkTerm = "main/network-term",
  SearchNetworkTerm = "main/network-term/search-network-term",
  AddNetworkTerm = "main/network-term/add-network-term",
  EditNetworkTerm = "main/network-term/edit-network-term",

  LpmManagement = "main/lpm-management",
  SearchLpmCompanies = "main/lpm-management/search-lpm-management",
  EditLpm = "main/lpm-management/edit-lpm",
  AddIndustryDiscounts = "main/lpm-management/add-industry-discounts",

  ProductManagement = "main/product-management",
  SearchProduct = "main/product-management/search-product",
  EditProduct = "main/product-management/edit-product",
  EditProductPricing = "main/product-management/edit-product-pricing",
  InsertProduct = "main/product-management/insert-product",

  TransactionalManagement = "main/transactional-management",

  PractitionerManagement = "main/practitioner-management",
  SearchPractitioner = "main/practitioner-management/search-practitioner",
  RegisterPractitioner = "main/practitioner-management/register-practitioner",
  EditPractitioner = "main/practitioner-management/edit-practitioner",

  ClusterManagement = "main/cluster-management",
  SearchClusterManagement = "main/cluster-management/search-cluster-management",
  EditCluster = "main/cluster-management/edit-cluster",
  AddCluster = "main/cluster-management/add-cluster",

  DrugstoreTests = "main/drugstore-tests",

  GeneralReport = "main/general-report",

  AuditSale = "main/audit-sale",
  AuditSaleDetails = "main/audit-sale/details/",

  TransactionLog = "main/transaction-log",

  DeliveryPanel = "main/delivery-panel",
}
